import styles from './OrderEngine.module.css'
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import TableItem, {TableItemCurrentStateInt, TableItemRef} from "../../FormTemplate/TableItem/TableItem";
import WaitLoader from "../../WaitLoader/WaitLoader";
import getOrderSate from "../../Util/getOrderSate";
import ActiveRecordItem from "../../FormTemplate/ActiveRecordItem/ActiveRecordItem";
import InputItem from "../../FormTemplate/InputItem/InputItem";
import ModalWindow from "../../FormTemplate/ModalWindow/ModalWindow";
import OrderEngineSim from "./Sim/OrderEngineSim";
import OrderEngineState from "./State/OrderEngineState";
import {SelectUnitDataInt} from "../../FormTemplate/SelectUnit/SelectUnit";
import OrderEngineStatus from "./Status/OrderEngineStatus";
import OrderEngineTrack from "./Track/OrderEngineTrack";
import {Link, useLocation} from "react-router-dom";
import OrderEngineComment from "./Comment/OrderEngineComment";
import OrderEngineAdminComment from "./Comment/OrderEngineAdminComment";
import OrderEngineTarifCard from "./TarifCard/OrderEngineTarifCard";
import OrderEngineHistory from "./History/OrderEngineHistory";
import ButtonContainer from "../../FormTemplate/ButtonContainer/ButtonContainer";
import ChangeTarif from "./ChangeTarif/ChangeTarif";
import OrderMapItem from "./OrderMap/OrderMapItem";
import OrderEngineChangePhone from "./ChangePhone/OrderEngineChangePhone";
import OrderEngineChangeDelivery from "./ChangeDelivery/OrderEngineChangeDelivery";
import MCCAItem from "./MCCAItem/MCCAItem";
import ChangePD from "./ChangePD/ChangePD";
import moment from "moment";
import ChangeRegMode from "./ChangeRegMode/ChangeRegMode";
import BeeAutoLanding from "./BeeAutoLanding/BeeAutoLanding";
import logoSms from '../../Img/Card/sms.png'
interface UpdateOrderInt
{
    orderId:string
    id?:number
    fieldList: string[]
    valList: any[]
    mode:number
}

interface OrderItemInt
{
    id:number
    state:number
    orderId:string
    regMode:number
    fullPrice:number
    macroRegionId:number
    regionId:number
    operId:string
    [key:string]:any
    createdAt: string
    processName:string
    processItemName: string
    deliveryStateName: string
    tarifId:string
    tarifName:string
    ctn:string
    coupon:string
    regModeName:string
    stateName:string
    authLogin:string
    icc?:string
    ip?:string
    family?:string
    direction?:string
    tempCtn?:string
    closed:boolean
    showAfter: string
    tmpCtn:string
    adminNote:string
    stateOne:{
        state:number
        subState: number
    }
}

interface OrderInfoReqInt
{
    orderId:string
}

interface ITotalOrderRank
{
    operId:string
    totalOrder:number
    percent?:number
    total?:number
}


interface OrderInfo
{
    orderId:string
    [key:string]:any
}

interface OrderStateListInt
{
    name:string
    code:number
}

export default function OrderEngine(){

    const errorLineRef = useRef<ErrorLineItemRef>(null)

    const location = useLocation()
    const tableRef = useRef<TableItemRef>(null)

    const [baseState, setBaseState] = useState<TableItemCurrentStateInt>()


    const [showSign, setShowSign] = useState(false)


    const updateIccRef = useRef<ErrorLineItemRef>(null)


    const [showSimUpdate, setShowSimUpdate] = useState(false)
    const [showStateUpdate, setShowStateUpdate] = useState(false)
    const [showOrderStatus, setShowOrderStatus] = useState(false)
    const [showOrderTrack, setShowOrderTrack] = useState(false)
    const [showComment,setShowComment] = useState(false)
    const [showAdminText,setShowAdminText] = useState(false)
    const [showTarifCard, setShowTarifCard] = useState(false)
    const [showOrderHistory, setShowOrderHistory] = useState(false)
    const [showOrderMap, setShowOrderMap] = useState(false)
    const [showSms, setShowSms] = useState(false)
    const [showMCCA, setShowMCCA] = useState(false)
    const [showBeeLanding, setShowBeeLanding] = useState(false)
    const [showChangePD, setShowChangePD] = useState(false)
    const [showChangeRegMode, setChangeRegMode] = useState(false)


    const [showChangePhone, setShowChangePhone] = useState(false)
    const [showChangeDelivery, setShowChangeDelivery] = useState(false)

    const [showTarifChange, setShowTarifChange] = useState(false)

    const [validAnyData ,setValidAnyData] = useState(false)



    const totalOrderData = useRef()
    const [ldrTotalOrder,rsTotalOrder,exTotalOrder] = useApiQuery("/sell/sim/order/ranks","post",totalOrderData);
    const [totalOrder, setTotalOrder] = useState<ITotalOrderRank[]>([])



    const orderStateData = useRef()
    const [ldrOrderState,rsOrderState,exOrderState] = useApiQuery("/ref/order/state/list","get",orderStateData);
    const [stateList, setStateList] = useState<OrderStateListInt[]>([])

    const [filterMode, setFilterMode] = useState(0)


    const [likeSearch, setLikeSearch] = useState("")

    const orderInfoData = useRef<OrderInfoReqInt>()
    const [ldrOrderInfo,rsOrderInfo,exOrderInfo] = useApiQuery("/sell/sim/order/info","post",orderInfoData);
    const [orderInfo, setOrderInfo] = useState<OrderInfo>()


    const orderUpdateData = useRef<UpdateOrderInt>()
    const [ldrOrderUpdate,rsOrderUpdate,exOrderUpdate] = useApiQuery("/sell/sim/order/update/field","post",orderUpdateData);


    const orderTrackData = useRef<OrderInfoReqInt>()
    const [ldrOrderTrack,rsOrderTrack,exOrderTrack] = useApiQuery("/sell/sim/order/delivery/track","post",orderInfoData);

    const orderTrackNotifyData = useRef<OrderInfoReqInt>()
    const [ldrOrderTrackNotify,rsOrderTrackNotify,exOrderTrackNotify] = useApiQuery("/sell/sim/order/delivery/notify","post",orderTrackNotifyData);


    const orderPrintData = useRef<OrderInfoReqInt>()
    const [ldrOrderPrint,rsOrderPrint,exOrderPrint] = useApiQuery("/sell/sim/order/delivery/print","post",orderPrintData);

    const orderListData = useRef<{
        mode:number // 0- активные 1-все 2-платные все
        xData?: string
    }>()
    const [ldrOrderList,rsOrderList,exOrderList] = useApiQuery("/sell/sim/order/list","post",orderListData);
    const [startOrderList, setStartOrderList] = useState<OrderItemInt[]>([])
    const [orderList, setOrderList] = useState<OrderItemInt[]>([])
    const [currentOrder, setCurrentOrder] = useState<any>()



    useEffect(()=>{
        loadTotalOrder()
    },[ startOrderList])


    useEffect(()=>{
        loadOrderState()
    },[orderStateData])


    useEffect(()=>{
        setOrderInfo(undefined)
        setCurrentOrder(undefined)
        //loadOrderList()
    },[orderListData])

    useEffect(()=>{
        console.log("changed current order record",currentOrder)
        if(!currentOrder)
        {
            setOrderInfo(undefined)
            return
        }
        loadOrderInfo()

    },[currentOrder])

    useEffect(()=>{

        if(stateList.length)
        {
            const path = location?.pathname
            const pathRg = path?.match(/(?<=\/lk\/order\/)[^\/]+/ui)
            if(pathRg){
                setFilterMode(2)
                loadOrderList(3, pathRg[0])
            }
            else loadOrderList()
        }

    },[stateList])


    useEffect(()=>{
        handleFilter(filterMode)
    },[filterMode, startOrderList])



    const loadTotalOrder = ()=>{
        exTotalOrder().then((e)=>{
            if(e?.success)
            {
                let x:ITotalOrderRank[] = e?.payload

                const total = x?.reduce((acc,item)=>acc+=item?.totalOrder, 0)
                x = x?.map((item)=>{
                    item.total = total
                    item.percent = Math.floor(item?.totalOrder / (total )*100)
                    return item
                })

                x = x?.sort((a,b)=>{
                    if(a?.totalOrder > b?.totalOrder) return -1
                    if(a?.totalOrder < b?.totalOrder) return 1
                    return 0
                })

                setTotalOrder(x)
                return
            }
            if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString :"Ошибка сервера",true,3000)

        })

    }

    const loadOrderState = ()=>{
        exOrderState().then((e)=>{
            if(e?.success)
            {
                setStateList(e?.payload)
                return
            }
            if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString :"Ошибка сервера",true,3000)

        })

    }
    const loadOrderInfo = ()=>{
        if(! currentOrder?.orderId) return
        orderInfoData.current = {
            orderId: currentOrder?.orderId
        }
        exOrderInfo().then((e)=> {
            if (e?.success)
            {
                console.log(e?.payload)
                setOrderInfo(e?.payload)
                //loadOrderList()
                return
            }
            if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,4000)
        })
    }

    const loadOrderList = (mode:number = 0, xData:string|null=null)=>{
        orderListData.current = {
            mode: mode,
            xData: xData ? xData : undefined
        }
        exOrderList().then((e)=> {
            if (e?.success && Array.isArray(e?.payload))
            {
                const x:OrderItemInt[] = e?.payload?.map((item)=>{
                    let regModeName = "Новый"
                    switch (item?.regMode)
                    {
                        case 10:
                            regModeName = "Портация" + (item?.simOne?.srcOper ? `: [${item?.simOne?.srcOper}]` : "")
                            break
                        case 1:
                        case 2:
                            regModeName = "Саморег"
                            break
                        case 0:
                            regModeName = "Обычный"
                            break


                    }
                    const x = stateList.filter((itm)=>itm?.code === item?.stateOne?.state)
                    const  stateName = x?.length ? x[0].name  : `[${item?.state}] Не определен`
                    const ctn = item?.simOne?.ctn ?  item?.simOne?.ctn : "-"


                    return{
                        operId:  item?.operId,
                        createdAt: item?.createdAt,
                        fullPrice: item?.fullPrice,
                        ctn: ctn,
                        icc: item?.simOne?.icc ? item?.simOne?.icc : "-",
                        tempCtn : item?.simOne?.tempCtn ? item?.simOne?.tempCtn : "-",
                        processName: item?.processName ?  item?.processName : '-',
                        processItemName: item?.processItemName ?  item?.processItemName : '-',
                        deliveryStateName: item?.deliveryStateName ? item?.deliveryStateName : "-",
                        deliveryName: item?.deliveryName ? item?.deliveryName : "-",
                        closed: item?.closed,
                        orderId: item?.orderId,
                        regionId: item?.regionId,
                        macroRegionId: item?.macroRegionId,
                        regMode: item?.regMode,
                        tarifId: item?.tarifOne?.terifId,
                        tarifName:item?.tarifOne?.name,
                        state: item?.state,

                        oneSubState: item?.stateOnr?.subState,
                        oneState: item?.stateOnr?.state,
                        id: item?.id,
                        regModeName: regModeName,
                        stateName: stateName,
                        authLogin: item?.authLogin,
                        ip: item?.ip,
                        family: item?.dkpOne?.family ? item?.dkpOne?.family : "-",
                        direction: item?.direction,
                        stateOne: item?.stateOne,
                        showAfter: item?.showAfter,
                        coupon: item?.coupon,
                        tmpCtn: item?.simOne?.tempCtn ? item?.simOne?.tempCtn : "-",
                        count: item?.count !==undefined ? item?.count : 0,
                        domain: item?.domain ? item?.domain : "main",
                        adminNote: item?.adminNote,
                    }
                })

                //setOrderList(x)

                switch (mode){
                    case 0:
                    case 1:
                    case 3:
                    case 4:
                        setStartOrderList(x)
                        break
                    case 2:
                        const px = startOrderList?.map((item)=>{

                            if(x?.length  && item?.orderId === x[0]?.orderId) return x[0]
                            return item
                        })
                        setStartOrderList(px)
                        break

                }

                return
            }

            if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,4000)
        })
    }


    const handlePrint = () =>{
        if(!currentOrder?.orderId)
        {
            if(errorLineRef?.current)errorLineRef?.current.show("Не выбран заказ",true,3000)
            return
        }
        orderPrintData.current = {
            orderId: currentOrder?.orderId
        }
        exOrderPrint().then((e)=>{
            if(e?.success)
            {
                console.log(e?.payload?.data)
                const arr = new Uint8Array(e?.payload?.data);
                const blob = new Blob([arr])
                const link = document.createElement('a')
                const url = URL.createObjectURL(blob)
                link.setAttribute('href', url);
                link.setAttribute('download', "print.pdf");
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                return
            }
            if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,4000)

        })

    }


    const handleNotify = () => {
        if(!currentOrder?.orderId)
        {
            if(errorLineRef?.current)errorLineRef?.current.show("Не выбран заказ",true,3000)
            return
        }
        orderTrackNotifyData.current = {
            orderId: currentOrder?.orderId
        }
        exOrderTrackNotify().then((e)=>{
            if(e?.success)
            {
                const txt = e?.payload?.text ? e?.payload?.text : "сообщение отправлено"
                if(errorLineRef.current)errorLineRef.current.show(txt,false,0)

                //  if(tableRef.current)tableRef.current.setActiveRow(currentOrder?.id)
                loadOrderList()
                setOrderInfo(undefined)

                return
            }

            if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,4000)
        })


    }

    const viewType = (data: any, active:boolean)=>{
        if(! data) return null
        const x = data?.toString()
        let color = styles.vcTypeBase
        if(x?.match(/порта/ui))
        {
            color = styles.vcTypePort
        }
        if(x?.match(/само/ui))
        {
            color = styles.vcTypeSelf
        }
        if(x?.match(/обы/ui))
        {
            color = styles.vcTypeMain
        }
        return (
            <div className={[styles.vcTypeBase, color, active ? styles.vcOperActive : ""].join(' ')}>{data}</div>
        )



    }
    const viewProcess = (data: any, active:boolean)=>{
        if(! data) return null
        const x = data?.toString()
        let color
        if(x?.match(/новый/ui))
        {
            color = styles.vcProcessNew
        }
        if(x?.match(/соглас/ui))
        {
            color = styles.vcProcessCall
        }
        return (
            <div className={[styles.vcTypeBase, color, active ? styles.vcOperActive : ""].join(' ')}>{data}</div>
        )



    }

    const viewDelivery = (data: any, active:boolean)=>{
        if(! data) return null
        const x = data?.toString()
        let color
        if(x?.match(/без /ui))
        {
            color = styles.vcDeliveryNo
        }
        return (
            <div className={[styles.vcTypeBase, color, active ? styles.vcOperActive : ""].join(' ')}>{data}</div>
        )



    }


    const viewOper= (data: any, active:boolean)=>{
        if(! data) return null
        const x = data?.toString()
        let color = styles.vcTele2
        if(x?.match(/beeline/ui))
        {
            color = styles.vcBeeline
        }
        if(x?.match(/megafon/ui))
        {
            color = styles.vcMegafon
        }
        if(x?.match(/mts/ui))
        {
            color = styles.vcMts
        }
        if(x?.match(/yota/ui))
        {
            color = styles.vcYota
        }
        if(x?.match(/tele2/ui))
        {
            color = styles.vcTele2
        }

        return (
            <div className={[styles.vcOper, color, active ? styles.vcOperActive : ""].join(' ')}>{data}</div>
        )

    }



    const handleTrack = () =>
    {
        if(!currentOrder?.orderId)
        {
            if(errorLineRef?.current)errorLineRef?.current.show("Не выбран заказ",true,3000)
            return
        }
        orderTrackData.current = {
            orderId: currentOrder?.orderId
        }
        exOrderTrack().then((e)=>{
            if(e?.success)
            {
                if(errorLineRef.current)errorLineRef.current.show(`Наряд по доставке по заказу ${currentOrder?.orderId} создан`,false,0)

              //  if(tableRef.current)tableRef.current.setActiveRow(currentOrder?.id)
                loadOrderList()
                setOrderInfo(undefined)

                return
            }

            if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true,4000)
        })



    }


    const handleFilter = (mode: number, reset:boolean = false)=>{
        const now = new Date()
        switch (mode)
        {
            case 0:
                const x = startOrderList?.filter((item)=> {
                    if(!item?.stateOne) return false
                    if(item?.stateOne && item?.stateOne?.state === 40) return false
                    if(item?.closed) return false
                    return true
                })
                setOrderList(x)
                break
            case 1:
                const p = startOrderList?.filter((item)=> {
                    if(!item?.stateOne) return false
                    if(item?.stateOne && item?.stateOne?.state === 40) return false
                    if(item?.closed) return false
                    if(item?.showAfter && (new Date(item?.showAfter) > now)) return false

                    return true
                })
                setOrderList(p)
                break
            case 2:
                //loadOrderList(1)
                setOrderList(startOrderList)
                break
            case 3:
            {
                const x = startOrderList?.filter((item)=> {
                    if(item?.closed) return false
                    if(item?.stateOne?.state === 50 && item?.stateOne?.subState === 0 ) return true
                    return false
                })
                setOrderList(x)
                break

            }
            case 4:
            {
                const x = startOrderList?.filter((item)=> {
                    if(item?.closed) return false
                    if(item?.stateOne?.state === 1 && item?.stateOne?.subState === 5 ) return true
                    return false
                })
                setOrderList(x)
                break

            }
            case 5:
            {
                const x = startOrderList?.filter((item)=> {
                    if(item?.closed) return false
                    if(item?.stateOne?.state === 2 && item?.stateOne?.subState === 4 ) return true
                    return false
                })
                setOrderList(x)
                break

            }


        }


    }

    const buildTotalOrder = ()=>{
        if(! totalOrder.length) return null

        const x = totalOrder?.map((item,idx)=>{
            return(
                <div key={idx} className={styles.toCont}>{item?.operId} - <span>{item?.totalOrder} [{item?.percent}%]</span></div>
            )
        })

        return (
            <div className={styles.likeMainCont}>
                <div className={styles.likeContMain}>{x}</div>
                <div className={styles.likeCount}>Всего заказов <span>{totalOrder[0]?.total}</span></div>
            </div>
        )
    }


    const ctn = currentOrder?.ctn?.length > 5 ? `${currentOrder?.ctn?.substring(0,3)}-${currentOrder?.ctn?.substring(3,6)}-${currentOrder?.ctn?.substring(6,10)}` : "-"


    const showSmsLogo = !!orderInfo?.appealCount

    return(
        <div className={styles.mainCont}>
            <div className={[styles.blkLine, styles.blkForm].join(' ')}>
                <MainFormTemplate title={"Стэк заказов"} maxWidth={"100%"}>
                    <div className={styles.titleCont}>
                        <ActiveRecordItem active={!!currentOrder}></ActiveRecordItem>
                        <WaitLoader loading={ldrOrderInfo} api={rsOrderInfo} onlyLoading={true}>

                        </WaitLoader>

                    </div>
                    <div className={styles.rowCont}>

                        <div className={styles.itmCont}>
                            <div className={styles.orTitleCont}>
                                <div className={styles.orTitle}>Данные заказа</div>

                                {showSmsLogo &&
                                    <div className={styles.orTitleImgCont}>
                                        <img src={logoSms} alt={"Событие"}/>
                                    </div>
                                }

                            </div>

                            <div className={"row w-100 g-1"}>
                                <div className={["col-xl-2 col-lg-4 col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={currentOrder?.orderId ? currentOrder?.orderId : ""}
                                        mode={"i"}
                                        info={"Номер заказа"}
                                        title={"Номер заказа"}
                                        titleShift={2}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-2 col-lg-4 col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={currentOrder?.createdAt ? new Date(currentOrder?.createdAt).toLocaleString()  : "Не определен"}
                                        mode={"i"}
                                        info={"Дата создания"}
                                        title={"Дата"}
                                        titleShift={-1}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-3 col-lg-4  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={currentOrder?.stateName ? currentOrder?.stateName  : "Не определен"}
                                        mode={"i"}
                                        info={"Статус заказа"}
                                        title={"Статус"}
                                        titleShift={-1}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-2 col-lg-6  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={ctn}
                                        mode={"ip"}
                                        info={`${orderInfo?.simOne?.srcRegion ? orderInfo?.simOne?.srcRegion : "Номер"}`}

                                        cssInput={styles.ctnColor}
                                        title={"CTN"}
                                        titleShift={-1}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-3 col-lg-6  col-md-12", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={currentOrder?.icc ? currentOrder?.icc  : "-"}
                                        mode={"i"}
                                        info={"ICC в заказе"}
                                        title={"ICC"}
                                        titleShift={-1}
                                    ></InputItem>
                                </div>

                            </div>
                            <div className={"row w-100 g-1"}>
                                <div className={["col-xl-2 col-lg-4  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={currentOrder?.regModeName ? currentOrder?.regModeName  : "Не определен"}
                                        mode={"i"}
                                        info={"Тип"}
                                        title={"Тип"}
                                        titleShift={-1}
                                        cssInput={currentOrder?.regModeName ? styles.cssRedInput : undefined}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-2 col-lg-4  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={currentOrder?.operId ? currentOrder?.operId  : "Не определен"}
                                        mode={"i"}
                                        info={"Оператор"}
                                        title={"Оператор"}
                                        titleShift={0}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-3 col-lg-4  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.tarifOne?.name ? orderInfo?.tarifOne?.name : "Не определен"}
                                        mode={"i"}
                                        info={"Тариф"}
                                        title={"Тариф"}
                                        titleShift={-1}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-3 col-lg-6  col-md-6" , styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.fullPrice ? orderInfo?.fullPrice : "Не определен"}
                                        mode={"i"}
                                        info={"Стоимость (руб)"}
                                        title={"Стоимость (руб.)"}
                                        titleShift={1}
                                        cssInput={orderInfo?.fullPrice ? styles.cssCostInput : undefined}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-2 col-lg-6  col-md-12", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.coupon ? orderInfo?.coupon : "-"}
                                        mode={"i"}
                                        info={`Купон [${orderInfo?.couponOne?.desc ? orderInfo?.couponOne?.desc : "Свободный"}]`}
                                        title={"Купон"}
                                        titleShift={0}
                                    ></InputItem>
                                </div>

                            </div>
                            <div className={"row w-100  g-1"}>
                                <div className={["col-xl-4 col-lg-6  col-md-7", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.regionOne?.name ? `[${orderInfo?.regionOne?.macroRegionId},${orderInfo?.regionOne?.regionId}] - ${orderInfo?.regionOne?.name}`  : "-"}
                                        mode={"i"}
                                        info={"Регион подключения"}
                                        title={"Регион"}
                                        titleShift={-2}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-3 col-lg-6  col-md-5", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.ip ? orderInfo?.ip  : "-"}
                                        mode={"i"}
                                        info={"IP"}
                                        title={"Ip"}
                                        titleShift={-1}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-3 col-lg-6  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={currentOrder?.tempCtn ? currentOrder?.tempCtn  : "-"}
                                        mode={"i"}
                                        info={"Временный номер"}
                                        title={"Врем. номер"}
                                        titleShift={1}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-2 col-lg-6  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.couponOne?.xData ? orderInfo?.couponOne?.xData  : "-"}
                                        mode={"i"}
                                        info={"Доб. дата к купону"}
                                        title={"Купон [xData]"}
                                        titleShift={1}
                                    ></InputItem>
                                </div>


                            </div>
                            <div className={styles.itmCont}>
                                <div className={styles.orTitle}>Данные для клиента</div>
                                <div className={"row w-100  g-1"}>
                                    <div className={["col-xl-12", styles.lsFont].join(' ')}>
                                        <InputItem
                                            val={orderInfo?.note ? orderInfo?.note  : "-"}
                                            mode={"i"}
                                            inputType={2}
                                            lineCount={3}

                                            info={"Дополнительная информация по заказу, только для клиента"}
                                            title={"Комментарий [ клиент ]"}
                                            titleShift={-2}
                                        ></InputItem>
                                    </div>
                                    <div className={styles.btnCont}>
                                        <button type="button" className="btn btn-secondary "
                                                disabled={currentOrder?.orderId === undefined}
                                                onClick={(e)=>{
                                                    setShowComment(true)
                                                }}
                                        >Комментарий</button>
                                    </div>
                                </div>
                            </div>

                            <div className={styles.itmCont}>
                                <div className={styles.orTitle}>Данные для администратора</div>
                                <div className={"row w-100  g-1"}>
                                    <div className={["col-xl-12", styles.lsFont].join(' ')}>
                                        <InputItem
                                            val={orderInfo?.adminNote ? orderInfo?.adminNote  : "-"}
                                            mode={"i"}
                                            info={"Дополнительная информация по заказу, только для администратора"}
                                            title={"Комментарий [ админ ]"}
                                            titleShift={-2}
                                        ></InputItem>
                                    </div>
                                    <div className={styles.btnCont}>
                                        <button type="button" className="btn btn-secondary "
                                                disabled={currentOrder?.orderId === undefined}
                                                onClick={(e)=>{
                                                    setShowAdminText(true)
                                                }}
                                        >Комментарий</button>
                                    </div>
                                </div>
                            </div>

                            {showOrderHistory &&
                                <OrderEngineHistory
                                    orderId={currentOrder?.orderId}
                                    onClose={()=>setShowOrderHistory(false)}
                                    onSuccess={()=>loadOrderList()}
                                />
                            }
                            {showOrderMap &&
                                <OrderMapItem
                                    orderId={currentOrder?.orderId}
                                    state={currentOrder?.state}
                                    regMode={currentOrder?.regMode}
                                    tempCtn={currentOrder?.tempCtn}
                                    ctn={currentOrder?.ctn}

                                    onClose={(mode:number)=>{
                                        setShowOrderMap(false)
                                        if(mode === 1)loadOrderList(2,currentOrder?.orderId)
                                        if(mode === 2){
                                            if(tableRef.current)tableRef.current.resetActiveRow()
                                            loadOrderList(2,currentOrder?.orderId)
                                        }
                                    }}

                                />
                            }


                            {showSimUpdate &&
                                <OrderEngineSim
                                    orderId={currentOrder?.orderId}
                                    onClose={()=>setShowSimUpdate(false)}
                                    pIcc={currentOrder?.icc}
                                    pCtn={currentOrder?.ctn}
                                    pTempCtn={currentOrder?.tempCtn}
                                    onSuccess={()=>loadOrderList(2,currentOrder?.orderId)}
                                />
                            }
                            {showStateUpdate &&
                                <OrderEngineState
                                    orderId={currentOrder?.orderId}
                                    onClose={()=>setShowStateUpdate(false)}
                                    onSuccess={()=>loadOrderList(2,currentOrder?.orderId)}
                                    pTextState={currentOrder?.stateName}
                                />
                            }
                            {showComment &&
                                <OrderEngineComment
                                    orderId={currentOrder?.orderId}
                                    onClose={()=>setShowComment(false)}
                                    textComment={orderInfo?.note}
                                    onSuccess={()=>loadOrderList(2,currentOrder?.orderId)}
                                />
                            }
                            {showAdminText &&
                                <OrderEngineAdminComment
                                    orderId={currentOrder?.orderId}
                                    onClose={()=>setShowAdminText(false)}
                                    textComment={orderInfo?.adminNote}
                                    onSuccess={()=>loadOrderList(2,currentOrder?.orderId)}
                                />
                            }
                            {showTarifCard &&
                                <OrderEngineTarifCard
                                    onClose={()=>setShowTarifCard(false)}
                                    tarifId={orderInfo?.tarifOne?.tarifId}
                                    macroRegionId={orderInfo?.macroRegionId}
                                    regionId={orderInfo?.regionId}

                                    //onSuccess={()=>loadOrderList()}
                                />
                            }
                            {showTarifChange && orderInfo &&
                                <ChangeTarif
                                    onClose={()=>{
                                        setShowTarifChange(false)
                                        loadOrderList()
                                        //loadOrderInfo()

                                    }}
                                    orderId={orderInfo?.orderId}
                                />
                            }

                            {showChangeRegMode &&
                                <ChangeRegMode
                                    orderId={currentOrder?.orderId}
                                    onClose={()=>setChangeRegMode(false)}
                                    onSuccess={()=>loadOrderList(2,currentOrder?.orderId)}
                                />
                            }
                            <div className={styles.actCont}>
                                <div className={styles.btnCont}>
                                    <button type="button" className="btn btn-secondary "
                                            disabled={currentOrder?.orderId === undefined}
                                            onClick={(e)=>{
                                                setShowOrderMap(true)
                                            }}
                                    >Карта заказа</button>
                                </div>
                                <div className={styles.btnCont}>
                                    <button type="button" className="btn btn-secondary "
                                            disabled={currentOrder?.orderId === undefined}
                                            onClick={(e)=>{
                                                setShowSimUpdate(true)
                                            }}
                                    >SIM</button>
                                </div>
                                <div className={styles.btnCont}>
                                    <button type="button" className="btn btn-secondary "
                                            disabled={currentOrder?.orderId === undefined}
                                            onClick={(e)=>{
                                                setChangeRegMode(true)
                                            }}
                                    >Тип заказа</button>
                                </div>
                            </div>
                        </div>

                        <div className={styles.itmCont}>
                            <div className={styles.orTitle}>Данные тарифа</div>
                            <div className={"row w-100  g-1"}>
                                <div className={["col-xl-3  col-lg-6  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.tarifOne?.name ? orderInfo?.tarifOne?.name : "Не определен"}
                                        mode={"i"}
                                        info={"Тариф"}
                                        title={"Тариф"}
                                        titleShift={-1}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-3  col-lg-6  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.tarifOne?.tarifId ? orderInfo?.tarifOne?.tarifId : "Не определен"}
                                        mode={"i"}
                                        info={"Код тарифа"}
                                        title={"Код тарифа"}
                                        titleShift={-1}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-6  col-lg-12  col-md-12", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.tarifBaseOne?.note ? orderInfo?.tarifBaseOne?.note : "-"}
                                        mode={"i"}
                                        info={"Дополнительная информация по тарифу"}
                                        title={"Доп. информация"}
                                        titleShift={-1}
                                    ></InputItem>
                                </div>
                            </div>

                            <div className={styles.actCont}>
                                <div className={styles.btnCont}>
                                    <button type="button" className="btn btn-secondary "
                                            disabled={currentOrder?.orderId === undefined}
                                            onClick={(e)=>{
                                                setShowTarifCard(true)
                                            }}
                                    >Карточка тарифа</button>
                                </div>
                                <div className={styles.btnCont}>
                                    <button type="button" className="btn btn-secondary "
                                            disabled={currentOrder?.orderId === undefined}
                                            onClick={(e)=>{
                                                setShowTarifChange(true)
                                            }}
                                    >Сменить тариф</button>
                                </div>
                                <div className={styles.btnCont}>
                                    { currentOrder?.operId?.match(/megafon/ui) &&
                                        <button type="button" className="btn btn-secondary "
                                                onClick={()=>setShowMCCA(true)}
                                        >MCCA</button>


                                    }
                                </div>
                                <div className={styles.btnCont}>
                                    { currentOrder?.operId?.match(/beeline/ui) &&
                                        <button type="button" className="btn btn-secondary "
                                                onClick={()=>setShowBeeLanding(true)}
                                        >Bee Landing</button>


                                    }
                                </div>

                            </div>

                            {showMCCA && orderInfo &&
                                <MCCAItem
                                    onClose={()=>setShowMCCA(false)}
                                    ctn={currentOrder?.ctn}
                                    tmpCtn={currentOrder?.tempCtn}
                                    orderId={currentOrder?.orderId}
                                />
                            }
                            {showBeeLanding && orderInfo &&
                                <BeeAutoLanding
                                    onClose={()=>{
                                        setShowBeeLanding(false)
                                        loadOrderList(2,currentOrder?.orderId)
                                    }}
                                    ctn={currentOrder?.ctn}
                                    tmpCtn={currentOrder?.tempCtn}
                                    orderId={currentOrder?.orderId}

                                />
                            }



                        </div>

                        <div className={styles.itmCont}>

                            <div className={styles.orTitle}>Данные клиента</div>
                            <div className={"row w-100  g-1"}>
                                <div className={["col-xl-2  col-lg-4  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.dkpOne?.family ? orderInfo?.dkpOne?.family  : "-"}
                                        mode={"i"}
                                        info={"Фамилия"}
                                        title={"Фамилия"}
                                        titleShift={0}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-2 col-lg-4  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.dkpOne?.name ? orderInfo?.dkpOne?.name  : "-"}
                                        mode={"i"}
                                        info={"Имя"}
                                        title={"Имя"}
                                        titleShift={0}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-2 col-lg-4  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.dkpOne?.middleName ? orderInfo?.dkpOne?.middleName  : "-"}
                                        mode={"i"}
                                        info={"Отчество"}
                                        title={"Отчество"}
                                        titleShift={0}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-3 col-lg-4  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.dkpOne?.birthDate ? new Date(orderInfo?.dkpOne?.birthDate).toLocaleString().substring(0,10)  : "-"}
                                        mode={"i"}
                                        info={"Дата рождения"}
                                        title={"Дата рождения"}
                                        titleShift={2   }
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-3 col-lg-8  col-md-12", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.dkpOne?.place ? orderInfo?.dkpOne?.place  : "-"}
                                        mode={"i"}
                                        info={"Место рождения"}
                                        title={"Место"}
                                        titleShift={-1}
                                    ></InputItem>
                                </div>
                            </div>
                            <div className={"row w-100  g-1"}>
                                <div className={["col-xl-2 col-lg-4  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.dkpOne?.serial ? orderInfo?.dkpOne?.serial  : "-"}
                                        mode={"i"}
                                        info={"Серия"}
                                        title={"Серия"}
                                        titleShift={0}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-2 col-lg-4  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.dkpOne?.number ? orderInfo?.dkpOne?.number  : "-"}
                                        mode={"i"}
                                        info={"Номер"}
                                        title={"Номер"}
                                        titleShift={0}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-2 col-lg-4  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.dkpOne?.depart ? orderInfo?.dkpOne?.depart  : "-"}
                                        mode={"i"}
                                        info={"Код подразделения"}
                                        title={"Код"}
                                        titleShift={1}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-3 col-lg-4  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.dkpOne?.issueDate ? new Date(orderInfo?.dkpOne?.issueDate).toLocaleString().substring(0,10)  : "-"}
                                        mode={"i"}
                                        info={"Дата выдачи"}
                                        title={"Дата выдачи"}
                                        titleShift={1}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-3 col-lg-8  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.userOne?.userDefineOne?.phone ? orderInfo?.userOne?.userDefineOne?.phone  : "-"}
                                        mode={"ip"}
                                        info={"Контактный телефон"}
                                        title={"Конт. тел."}
                                        titleShift={0}
                                        cssInput={orderInfo?.userOne?.userDefineOne?.phone ? styles.cssBlueInput : undefined}
                                    ></InputItem>
                                </div>
                            </div>
                            <div className={"row w-100  g-1"}>
                                <div className={["col-xl-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.dkpOne?.addressOne?.textAddress ? orderInfo?.dkpOne?.addressOne?.textAddress  : "-"}
                                        mode={"i"}
                                        info={"Адрес"}
                                        title={"Адрес"}
                                        titleShift={-2}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-3", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.userOne?.userDefineOne?.eMail ? orderInfo?.userOne?.userDefineOne?.eMail  : "-"}
                                        mode={"i"}
                                        info={"Контактный e-mail"}
                                        title={"Конт. e-mail"}
                                        titleShift={0}
                                        cssInput={styles.cssBlueInput}
                                    ></InputItem>
                                </div>
                            </div>
                            <div className={styles.actCont}>
                                <div className={styles.btnCont}>
                                    <button type="button" className="btn btn-secondary d-none"
                                            onClick={(e)=>setShowSms(! showSms)}
                                            disabled={!currentOrder}
                                    >SMS</button>

                                </div>
                                { orderInfo?.dkpOne?.sign &&
                                    <div className={styles.btnCont}>
                                        <button type="button" className="btn btn-secondary "
                                                onClick={(e)=>setShowSign(! showSign)}
                                        >Подпись</button>

                                    </div>

                                }
                                <div className={styles.btnCont}>
                                    <button type="button" className="btn btn-secondary "
                                            onClick={(e)=>setShowChangePhone(true)}
                                            disabled={currentOrder?.orderId === undefined}
                                    >Сменить конт.телефон</button>

                                </div>
                                <div className={styles.btnCont}>
                                    <button type="button" className="btn btn-secondary "
                                            onClick={(e)=>setShowChangePD(true)}
                                            disabled={currentOrder?.orderId === undefined || !(currentOrder?.regMode===10 || currentOrder?.regMode === 0)}
                                    >Сменить перс.данные</button>

                                </div>


                                {showChangePhone &&
                                    <OrderEngineChangePhone
                                        onClose={()=>setShowChangePhone(false)}
                                        orderId={currentOrder?.orderId}
                                        pCtn={orderInfo?.userOne?.userDefineOne?.phone}
                                        onSuccess={()=>loadOrderList(2,currentOrder?.orderId)}
                                    />
                                }
                                {showChangePD &&
                                    <ChangePD
                                        onClose={()=>setShowChangePD(false)}
                                        dkpId={orderInfo?.dkpOne?.id}
                                        onSuccess={()=>loadOrderList(2,currentOrder?.orderId)}
                                        data={{
                                            family: orderInfo?.dkpOne?.family,
                                            name: orderInfo?.dkpOne?.name,
                                            middleName: orderInfo?.dkpOne?.middleName,
                                            serial: orderInfo?.dkpOne?.serial,
                                            number: orderInfo?.dkpOne?.number,
                                            docDate: moment(orderInfo?.dkpOne?.issueDate).format('DD.MM.YYYY'),
                                            depart: orderInfo?.dkpOne?.depart,
                                            birthDate: moment(orderInfo?.dkpOne?.birthDate).format('DD.MM.YYYY'),
                                        }}
                                    />
                                }


                                { showSign &&
                                    <ModalWindow onClose={()=>setShowSign(false)}>
                                        <div className={styles.signCont}>
                                            <img src={orderInfo?.dkpOne?.sign}></img>
                                            <div className={styles.btnCont}>
                                                <button type="button" className="btn btn-secondary "
                                                        onClick={(e)=>setShowSign(false)}
                                                >Закрыть</button>

                                            </div>
                                        </div>
                                    </ModalWindow>
                                }

                            </div>
                        </div>

                        <div className={styles.itmCont}>
                            <div className={styles.orTitle}>Данные оплаты</div>
                            <div className={"row w-100  g-1"}>
                                <div className={["col-xl-3 col-lg-6  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.paymentOne?.customerId ? orderInfo?.paymentOne?.customerId  : "-"}
                                        mode={"i"}
                                        info={"Оператор"}
                                        title={"Оператор"}
                                        titleShift={1}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-3  col-lg-6  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.paymentOne?.paymentType ? orderInfo?.paymentOne?.paymentType  : "-"}
                                        mode={"i"}
                                        info={"Тип оплаты"}
                                        title={"Тип оплаты"}
                                        titleShift={1}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-3  col-lg-6  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.paymentOne?.transactionId ? orderInfo?.paymentOne?.transactionId  : "-"}
                                        mode={"i"}
                                        info={"Транзакция"}
                                        title={"Транзакция"}
                                        titleShift={0}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-3  col-lg-6  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.paymentOne?.amount ? orderInfo?.paymentOne?.amount  : "-"}
                                        mode={"i"}
                                        info={"Сумма"}
                                        title={"Сумма"}
                                        titleShift={1}
                                    ></InputItem>
                                </div>
                            </div>
                        </div>

                        <div className={styles.itmCont}>
                            <div className={styles.orTitle}>Данные оператора доставки</div>
                            <div className={"row w-100 g-1"}>
                                <div className={["col-xl-3  col-lg-6  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.deliveryOne?.deliveryTypeOne?.name ? orderInfo?.deliveryOne?.deliveryTypeOne?.name  : "-"}
                                        mode={"i"}
                                        info={"Оператор доставки"}
                                        title={"Оператор доставки"}
                                        titleShift={1}
                                        cssInput={orderInfo?.deliveryOne?.deliveryTypeOne?.name ? styles.cssGreenInput : undefined}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-2   col-lg-6  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.deliveryOne?.pointId ? orderInfo?.deliveryOne?.pointId  : "-"}
                                        mode={"i"}
                                        info={"Пункт"}
                                        title={"Пункт"}
                                        titleShift={0}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-3   col-lg-4  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.deliveryOne?.track ? orderInfo?.deliveryOne?.track  : "-"}
                                        mode={"i"}
                                        info={"Трэк"}
                                        title={"Трэк"}
                                        titleShift={-1}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-2   col-lg-4  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.deliveryOne?.price ? orderInfo?.deliveryOne?.price  : "-"}
                                        mode={"i"}
                                        info={"Цена"}
                                        title={"Цена"}
                                        titleShift={-1}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-2   col-lg-4  col-md-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.deliveryOne?.phone ? orderInfo?.deliveryOne?.phone  : "-"}
                                        mode={"ip"}
                                        info={"Телефон"}
                                        title={"Телефон"}
                                        titleShift={0}
                                    ></InputItem>
                                </div>
                            </div>
                            <div className={"row w-100 g-1"}>
                                <div className={["col-xl-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.direction ? orderInfo?.direction   : "-"}
                                        mode={"i"}
                                        info={"Адрес"}
                                        title={"Адрес"}
                                        titleShift={-3}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-6", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={currentOrder?.deliveryStateName}
                                        mode={"i"}
                                        info={"Статус доставки"}
                                        title={"Статус"}
                                        titleShift={-1}
                                    ></InputItem>
                                </div>
                            </div>
                            <div className={styles.actCont}>
                                <div className={styles.btnCont}>
                                    <button type="button" className="btn btn-secondary "
                                            onClick={(e)=>handleTrack()}
                                            disabled={currentOrder?.orderId === undefined}
                                    >Сформировать</button>
                                </div>
                                <div className={styles.btnCont}>
                                    <button type="button" className="btn btn-secondary "
                                            onClick={(e)=>handlePrint()}
                                            disabled={currentOrder?.orderId === undefined}
                                    >Напечатать</button>
                                </div>

                                <div className={styles.btnCont}>
                                    <button type="button" className="btn btn-secondary "
                                            onClick={(e)=>setShowOrderStatus(true)}
                                            disabled={currentOrder?.orderId === undefined}
                                    >Отследить</button>
                                </div>

                                <div className={styles.btnCont}>
                                    <button type="button" className="btn btn-secondary "
                                            onClick={(e)=>handleNotify()}
                                            disabled={currentOrder?.orderId === undefined}
                                    >Оповестить</button>
                                </div>

                                <div className={styles.btnCont}>
                                    <button type="button" className="btn btn-secondary "
                                            onClick={(e)=>setShowOrderTrack(true)}
                                            disabled={currentOrder?.orderId === undefined}
                                    >Трек</button>
                                </div>
                                <div className={styles.btnCont}>
                                    <button type="button" className="btn btn-secondary "
                                            onClick={(e)=>setShowChangeDelivery(true)}
                                            disabled={currentOrder?.orderId === undefined}
                                    >Сменить опер.доставки</button>
                                </div>


                                {showOrderStatus &&
                                    <OrderEngineStatus orderId={currentOrder?.orderId} onClose={()=>setShowOrderStatus(false)}
                                    />

                                }
                                {showOrderTrack &&
                                    <OrderEngineTrack orderId={currentOrder?.orderId} pTrack={orderInfo?.deliveryOne?.track} onClose={()=>setShowOrderTrack(false)}
                                                      onSuccess={()=>loadOrderList()}
                                    />

                                }

                                {showChangeDelivery &&
                                    <OrderEngineChangeDelivery
                                        onClose={()=>setShowChangeDelivery(false)}
                                        orderId={currentOrder?.orderId}
                                        onSuccess={()=>loadOrderList()}
                                    />
                                }


                                <div className={styles.ldrCont}>
                                    <WaitLoader loading={ldrOrderTrack || ldrOrderPrint || ldrOrderTrackNotify } api={rsOrderTrack} onlyLoading={true}>

                                    </WaitLoader>
                                </div>
                            </div>


                        </div>

                    </div>


                    <ErrorLineItem ref={errorLineRef} ></ErrorLineItem>
                </MainFormTemplate>
            </div>

            <div className={[styles.blkLine, styles.blkTable].join(' ')}>
                <div className={styles.fltrCont}>

                    <ButtonContainer resize={true} clsCont={styles.likeSearch} my={10}>
                        <input className={"form-control form-control-sm"}
                               maxLength={20}
                               value={likeSearch}
                               onChange={(e)=>setLikeSearch(e?.target?.value)}

                        />
                        <button type="button" className="btn btn-secondary "
                                disabled={likeSearch?.length < 3}
                                onClick={()=>{
                                    if(tableRef.current )tableRef.current.resetActiveRow()
//                                setFilterMode(0)
                                    setFilterMode(2)
                                    loadOrderList(4, likeSearch)
                                }}
                        >like поиск</button>



                    </ButtonContainer>

                    <ButtonContainer resize={true} clsCont={styles.rzButton}>
                        <button type="button" className="btn btn-secondary "
                                onClick={()=>{
                                    if(tableRef.current )tableRef.current.resetActiveRow()
                                    setFilterMode(0)
                                    loadOrderList()
                                }}
                        >Обновить</button>
                        <button type="button" className="btn btn-secondary "
                                onClick={()=>{
                                    if(tableRef.current )tableRef.current.resetActiveRow()
                                    setFilterMode(0)
                                }}
                        >Активные</button>

                        <button type="button" className="btn btn-secondary "
                                onClick={()=>{
                                    if(tableRef.current )tableRef.current.resetActiveRow()
                                    setFilterMode(1)
                                }}
                        >Приоритетные</button>

                        <button type="button" className="btn btn-secondary "
                                onClick={()=>{
                                    if(tableRef.current )tableRef.current.resetActiveRow()
                                    setFilterMode(3)
                                }}
                        >Новые</button>

                        <button type="button" className="btn btn-secondary "
                                onClick={()=>{
                                    if(tableRef.current )tableRef.current.resetActiveRow()
                                    setFilterMode(4)
                                }}
                        >Согласованные</button>
                        <button type="button" className="btn btn-secondary "
                                onClick={()=>{
                                    if(tableRef.current )tableRef.current.resetActiveRow()
                                    setFilterMode(5)
                                }}
                        >Приостановленные</button>


                        <button type="button" className="btn btn-secondary "
                                onClick={()=>{
                                    if(tableRef.current )tableRef.current.resetActiveRow()
                                    setFilterMode(2)
                                    loadOrderList(1, currentOrder?.orderId)
                                }}
                                disabled={!currentOrder}
                        >От клиента</button>


                        <button type="button" className="btn btn-secondary "
                                onClick={()=>{
                                    if(tableRef.current )tableRef.current.resetActiveRow()
                                    setFilterMode(2)
                                    loadOrderList(1)
                                }}
                        >Все</button>



                    </ButtonContainer>

                </div>

                <WaitLoader loading={ldrOrderList} api={rsOrderList} onlyLoading={true}>
                <TableItem
                    column={[
                        {
                            title:"Домен",
                            type: 0,
                            maxLen: 20,
                            fieldId:"domain",
                            mode: "sf",
                        },
                        {
                            title:"Дата",
                            type: 4,
                            maxLen: 20,
                            fieldId:"createdAt",
                            mode: "sf",
                        },
                        {
                            title:"Заказ",
                            type: 0,
                            maxLen: 11,
                            fieldId:"orderId",
                            mode: "sf",
                        },
                        {
                            title:"Оператор",
                            type: 0,
                            maxLen: 10,
                            fieldId:"operId",
                            mode: "sf",
                            onView: (e,k)=>viewOper(e,k)
                        },
                        {
                            title:"Тип",
                            type: 0,
                            maxLen: 30,
                            fieldId:"regModeName",
                            mode: "fs",
                            onView: (e,k)=>viewType(e,k)
                        },
                        {
                            title:"Номер",
                            type: 0,
                            maxLen: 20,
                            fieldId:"ctn",
                            mode: "sf",
                        },
                        {
                            title:"Врем.номер",
                            type: 0,
                            maxLen: 20,
                            fieldId:"tmpCtn",
                            mode: "sf",
                        },
                        {
                            title:"Фамилия",
                            type: 0,
                            maxLen: 20,
                            fieldId:"family",
                            mode: "sf",
                        },
                        {
                            title:"Кол.",
                            type: 1,
                            maxLen: 20,
                            fieldId:"count",
                            mode: "s",
                        },
                        {
                            title:"Процесс",
                            type: 0,
                            maxLen: 40,
                            fieldId:"processName",
                            mode: "fs",
                            onView:(e,k)=>viewProcess(e,k)
                        },
                        {
                            title:"Задача",
                            type: 0,
                            maxLen: 50,
                            fieldId:"processItemName",
                            mode: "fs",
                        },

                        {
                            title:"Доставка",

                            type: 0,
                            maxLen: 30,
                            fieldId:"deliveryName",
                            mode: "fs",
                            onView:(e,k)=>viewDelivery(e,k)
                        },
                        {
                            title:"Login",
                            type: 0,
                            maxLen: 30,
                            fieldId:"authLogin",
                            mode: "sf",
                        },
                        {
                            title:"Купон",
                            type: 0,
                            maxLen: 30,
                            fieldId:"coupon",
                            mode: "sf",
                        },
                        {
                            title:"Комент",
                            type: 0,
                            fieldId:"adminNote",
                            mode: "h",
                        },
                        {
                            title:"Закрыт",
                            type: 5,
                            maxLen: 30,
                            fieldId:"closed",
                            mode: "s",
                        },


                    ]}
                    onPageCount={30}
                    data={orderList}
                    exportExcel={true}
                    onReload={()=>loadOrderList()}
                    ref={tableRef}
                    saveState={true}

                    onRecord={(e)=>setCurrentOrder(e)}
                    baseState={{
                        state: baseState,
                        setState: setBaseState
                    } }

                ></TableItem>
                    {buildTotalOrder()}



            </WaitLoader>
            </div>
        </div>

    )
}